import { footerData } from '@/mocks/home';

export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-secondary-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-12">
            <div>
              <span className="text-xl font-heading font-bold text-primary-400 mb-4 block">
                51吃瓜网
              </span>
              <p className="text-sm text-secondary-300 leading-relaxed mb-4">
                {footerData.description}
              </p>
              <div className="flex items-center gap-3">
                <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-800 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-800 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-800 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer">
                  <i className="ri-links-line text-lg"></i>
                </a>
              </div>
            </div>

            {footerData.sections.map((section) => (
              <div key={section.title}>
                <h3 className="text-sm font-semibold text-background-50 mb-4">
                  {section.title}
                </h3>
                <ul className="space-y-2.5">
                  {section.links.map((link) => (
                    <li key={link.name}>
                      <a
                        href={link.href}
                        onClick={(e) => handleNavClick(e, link.href)}
                        className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                      >
                        {link.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="border-t border-secondary-800 pt-8">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-secondary-400">
                &copy; {new Date().getFullYear()} 51吃瓜网入口. 本站内容仅供娱乐参考，不构成任何建议。
              </p>
              <div className="flex items-center gap-4 text-xs text-secondary-400">
                <span>合作伙伴</span>
                <span className="text-secondary-600">——</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}